import React, { useState, useEffect } from "react";
import Layout from "../components/Layout";
import { useParams, useNavigate } from "react-router-dom";
import API_BASE from "../config.js";
import { useTranslation } from "react-i18next";
import useTextosSegmento from "../i18n/useTextosSegmento";
import { authFetch } from "../services/authFetch";


// Extrai tenant_id do JWT token - evita conflito entre tenants
function getTenantIdFromToken() {
  try {
    const token = (sessionStorage.getItem("access_token")||localStorage.getItem("access_token"));
    if (!token) return (sessionStorage.getItem("tenant_id")||localStorage.getItem("tenant_id")) || "1";
    const payload = JSON.parse(atob(token.split(".")[1]));
    return String(payload.tenant_id || (sessionStorage.getItem("tenant_id")||localStorage.getItem("tenant_id")) || "1");
  } catch { return (sessionStorage.getItem("tenant_id")||localStorage.getItem("tenant_id")) || "1"; }
}

const API = "" + API_BASE + "/api/v1/dados";
const STATUS_COR = {
  "Recepcao":"#6366f1","Diagnostico":"#f59e0b","Aguardando Aprovacao":"#f97316",
  "Em Servico":"#3b82f6","Aguardando Pecas":"#eab308","Concluido":"#22c55e","Entregue":"#94a3b8"
};

export default function OrcamentoDetalhe() {
  const { t } = useTranslation();
  // AUD-F: t() sensivel ao segmento, para as chamadas de vocabulario
  // de veiculo desta tela. O resto segue no t() de sempre.
  const { tSeg } = useTextosSegmento();
  const STATUS_LABEL = (s) => t("os.status." + s, s);
  const { osId } = useParams();
  const navigate = useNavigate();
  const tenantId = getTenantIdFromToken() || "1";
  const ARQUIVO_KEY = "orcamentos_arquivados_" + tenantId;
  const [os, setOs] = useState(null);
  const [orc, setOrc] = useState(null);
  const [orcCfg, setOrcCfg] = useState(null);
  const [arquivados, setArquivados] = useState(() => {
    try { return JSON.parse(localStorage.getItem(ARQUIVO_KEY) || "[]"); } catch { return []; }
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    authFetch(API + "/os/" + tenantId, {})
      .then(r=>r.ok?r.json():[])
      .then(d=>{
        const found = d.find(o=>o.id===osId);
        if(found){
          setOs(found);
          try { setOrc(JSON.parse(found.orcamento)); } catch{}
          // Carregar status arquivado do banco
          if(found.arquivado) setArquivados(prev=>[...prev, osId]);
        }
      })
      .catch(()=>{})
      .finally(()=>setLoading(false));
  }, [osId]);

  // Dados institucionais da oficina (nome, telefone, endereco, CNPJ, email) para exibir no PDF
  useEffect(() => {
    authFetch(API_BASE + "/api/v1/config/orcamento_config_tenant_" + tenantId + "?t=" + Date.now())
      .then(r => r.ok ? r.json() : null)
      .then(d => { if (d && d.value) setOrcCfg(d.value); })
      .catch(() => {});
  }, [tenantId]);

  const arquivar = () => {
    const novoStatus = !arquivados.includes(osId);
    const novos = novoStatus ? [...arquivados, osId] : arquivados.filter(a=>a!==osId);
    // Salvar no localStorage imediatamente para resposta rapida
    localStorage.setItem(ARQUIVO_KEY, JSON.stringify(novos));
    setArquivados(novos);
    // Salvar no banco para persistencia total
    authFetch(`${API}/os/${tenantId}/${osId}/arquivar`, {
      method:"PATCH",
      headers:{"Content-Type":"application/json"},
      body:JSON.stringify({arquivado: novoStatus})
    }).catch(()=>{});
  };

  const exportarPDF = () => {
    if(!os||!orc) return;
    const itens = orc.itens||[];
    const nomeOficina = orcCfg?.nomeEmpresa || "";
    const cabecalhoOficina = `
    <div style="display:flex;align-items:flex-start;justify-content:space-between;margin-bottom:16px;padding-bottom:12px;border-bottom:2px solid #e2e8f0">
      <div>
        ${orcCfg?.logoUrl ? `<img src="${orcCfg.logoUrl}" alt="logo" style="height:60px;object-fit:contain;display:block;margin-bottom:6px" />` : ""}
        ${nomeOficina ? `<div style="color:#1e40af;font-size:18px;font-weight:800">${nomeOficina}</div>` : ""}
        ${orcCfg?.telefone ? `<div style="color:#64748b;font-size:12px">${t("orcamentos.print_tel_prefix")} ${orcCfg.telefone}</div>` : ""}
        ${orcCfg?.endereco ? `<div style="color:#64748b;font-size:12px">${orcCfg.endereco}</div>` : ""}
        ${orcCfg?.documento ? `<div style="color:#64748b;font-size:12px">CNPJ/CPF: ${orcCfg.documento}</div>` : ""}
        ${orcCfg?.email ? `<div style="color:#64748b;font-size:12px">${orcCfg.email}</div>` : ""}
      </div>
    </div>`;
    const html = `<!DOCTYPE html><html><head><meta charset="utf-8"><title>${t("orcamentos.modal_orcamento_label")} ${os.id}</title>
    <style>body{font-family:Arial,sans-serif;padding:32px;color:#1e293b}h1{color:#1e40af;font-size:20px}
    table{width:100%;border-collapse:collapse;margin-top:16px}th{background:#1e40af;color:#fff;padding:10px;text-align:left}
    td{padding:9px;border-bottom:1px solid #e2e8f0}.total{text-align:right;font-size:18px;font-weight:bold;color:#1e40af;margin-top:16px}
    .info{display:grid;grid-template-columns:1fr 1fr;gap:12px;margin:16px 0}.info-box{background:#f8fafc;padding:12px;border-radius:8px}
    .label{font-size:10px;font-weight:700;text-transform:uppercase;color:#64748b;margin-bottom:4px}
    @media print{body{padding:16px}}</style></head>
    <body>${cabecalhoOficina}<h1>${t("orcamentos.modal_orcamento_label")} - ${os.id}</h1><div class="info">
    <div class="info-box"><div class="label">${t("orcamentos.print_cliente")}</div><div>${os.cliente}</div><div style="color:#64748b;font-size:12px">${os.telefone||""}</div></div>
    <div class="info-box"><div class="label">${tSeg("orcamentos.info_veiculo")}</div><div>${os.veiculo}</div><div style="color:#1e40af;font-weight:700">${os.placa||""}</div></div>
    <div class="info-box"><div class="label">${t("orcamentos.info_status")}</div><div>${STATUS_LABEL(os.status)}</div></div>
    <div class="info-box"><div class="label">${t("orcamentos.info_data")}</div><div>${os.criada||""}</div></div></div>
    <table><thead><tr><th>${t("orcamentos.col_servico_peca")}</th><th>${t("orcamentos.col_qtd")}</th><th>${t("orcamentos.col_valor_unit")}</th><th>${t("orcamentos.col_total")}</th></tr></thead><tbody>
    ${itens.map(i=>`<tr><td>${i.nome}</td><td>${i.qtd||1}</td><td>R$ ${(Number(i.preco)/(i.qtd||1)).toFixed(2)}</td><td>R$ ${Number(i.preco).toFixed(2)}</td></tr>`).join("")}
    </tbody></table><div class="total">${t("orcamentos.print_total_prefix")} R$ ${(os.total||0).toLocaleString("pt-BR",{minimumFractionDigits:2})}</div>
    <div style="margin-top:48px;display:grid;grid-template-columns:1fr 1fr;gap:40px">
    <div style="text-align:center;border-top:1px solid #94a3b8;padding-top:8px;font-size:12px;color:#64748b">${t("orcamentos.print_assinatura_responsavel")}</div>
    <div style="text-align:center;border-top:1px solid #94a3b8;padding-top:8px;font-size:12px;color:#64748b">${t("orcamentos.print_assinatura_cliente")}</div></div>
    </body></html>`;
    const w = window.open("","_blank");
    w.document.write(html);
    w.document.close();
    // Correcao pontual: esperar o carregamento real da janela (imagens/logo)
    // em vez de um atraso fixo de 500ms, que podia disparar a impressao
    // antes do conteudo terminar de renderizar (falha intermitente).
    w.onload = () => { w.focus(); w.print(); };
  };

  if(loading) return <Layout><div style={{padding:40,textAlign:"center",color:"var(--text3)"}}>{t("common.carregando")}</div></Layout>;
  if(!os) return <Layout><div style={{padding:40,textAlign:"center",color:"var(--text3)"}}>{t("orcamentos.nao_encontrado")}</div></Layout>;

  const isArquivado = arquivados.includes(osId);

  return (
    <Layout>
      <div style={{maxWidth:900,margin:"0 auto"}}>
        <div style={{alignItems:"center",display:"flex",gap:12,marginBottom:24,flexWrap:"wrap"}}>
          <button onClick={()=>navigate("/orcamentos")}
            style={{background:"var(--bg3)",border:"1px solid var(--border)",borderRadius:8,color:"var(--text2)",cursor:"pointer",fontSize:13,padding:"8px 16px"}}>
            ← {t("common.voltar")}
          </button>
          <div style={{flex:1}}>
            <div style={{color:"var(--accent2)",fontSize:12,marginBottom:2}}>{t("orcamentos.modal_orcamento_label")}</div>
            <div style={{fontSize:20,fontWeight:800}}>{os.id} — {os.cliente}</div>
          </div>
          <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
            <button onClick={exportarPDF}
              style={{background:"#3b82f6",border:"none",borderRadius:8,color:"#fff",cursor:"pointer",fontSize:13,fontWeight:700,padding:"10px 18px"}}>
              {t("orcamentos.exportar_pdf")}
            </button>
            <button onClick={arquivar}
              style={{background:isArquivado?"#22c55e22":"#f59e0b22",border:"1px solid "+(isArquivado?"#22c55e":"#f59e0b"),borderRadius:8,color:isArquivado?"#22c55e":"#f59e0b",cursor:"pointer",fontSize:13,padding:"10px 18px"}}>
              {isArquivado?t("orcamentos.desarquivar"):t("orcamentos.arquivar")}
            </button>
          </div>
        </div>

        {isArquivado&&<div style={{background:"#f59e0b22",border:"1px solid #f59e0b",borderRadius:8,color:"#f59e0b",fontSize:13,marginBottom:16,padding:"10px 16px"}}>{t("orcamentos.este_esta_arquivado")}</div>}

        <div style={{display:"grid",gap:12,gridTemplateColumns:"repeat(auto-fit,minmax(140px,1fr))",marginBottom:24}}>
          {[
            [tSeg("orcamentos.info_veiculo"),os.veiculo],
            [t("orcamentos.info_placa"),os.placa||"—"],
            [t("orcamentos.info_status"),STATUS_LABEL(os.status)],
            [t("orcamentos.info_data"),os.criada||"—"],
            [t("orcamentos.info_tecnico"),os.tecnico||"—"],
            [t("orcamentos.info_modelo"),orc?.modelo||"basico"],
            [t("orcamentos.info_total"),"R$ "+(os.total||0).toLocaleString("pt-BR",{minimumFractionDigits:2})]
          ].map(([l,v])=>(
            <div key={l} style={{background:"var(--bg3)",borderRadius:8,padding:14}}>
              <div style={{color:"var(--text3)",fontSize:10,fontWeight:700,marginBottom:4,textTransform:"uppercase"}}>{l}</div>
              <div style={{fontSize:13,fontWeight:600}}>{v}</div>
            </div>
          ))}
        </div>

        {orc && (
          <div className="card" style={{marginBottom:20}}>
            <div style={{color:"var(--text3)",fontSize:11,fontWeight:700,marginBottom:14,textTransform:"uppercase"}}>{t("orcamentos.itens_do_orcamento")}</div>
            <table style={{borderCollapse:"collapse",width:"100%"}}>
              <thead><tr style={{background:"var(--bg3)"}}>
                {[t("orcamentos.col_servico_peca"),t("orcamentos.col_qtd"),t("orcamentos.col_valor_unit"),t("orcamentos.col_total")].map(h=>(
                  <th key={h} style={{color:"var(--text2)",fontSize:11,fontWeight:700,padding:"10px 12px",textAlign:"left"}}>{h}</th>
                ))}
              </tr></thead>
              <tbody>
                {(orc.itens||[]).map((item,i)=>(
                  <tr key={i} style={{borderBottom:"1px solid var(--border)"}}>
                    <td style={{fontSize:13,padding:"11px 12px"}}>{item.nome}</td>
                    <td style={{fontSize:13,padding:"11px 12px"}}>{item.qtd||1}</td>
                    <td style={{fontSize:13,padding:"11px 12px"}}>R$ {(Number(item.preco)/(item.qtd||1)).toFixed(2)}</td>
                    <td style={{fontSize:13,fontWeight:600,padding:"11px 12px"}}>R$ {Number(item.preco).toFixed(2)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div style={{display:"flex",justifyContent:"flex-end",marginTop:16}}>
              <div style={{background:"var(--bg3)",borderRadius:8,padding:"14px 20px",textAlign:"right"}}>
                <div style={{color:"var(--text3)",fontSize:11}}>{t("orcamentos.total_do_orcamento")}</div>
                <div style={{color:"#22c55e",fontSize:24,fontWeight:900}}>R$ {(os.total||0).toLocaleString("pt-BR",{minimumFractionDigits:2})}</div>
              </div>
            </div>
          </div>
        )}

        {orc?.fotos&&orc.fotos.length>0&&(
          <div className="card">
            <div style={{color:"var(--text3)",fontSize:11,fontWeight:700,marginBottom:14,textTransform:"uppercase"}}>{t("orcamentos.registro_fotografico")}</div>
            <div style={{display:"grid",gap:10,gridTemplateColumns:"repeat(auto-fill,minmax(180px,1fr))"}}>
              {orc.fotos.map((foto,i)=>(
                <div key={i} style={{borderRadius:8,overflow:"hidden",border:"1px solid var(--border)"}}>
                  <img src={foto.url||foto} alt={t("orcamentos.foto_n",{n:i+1})} style={{height:140,objectFit:"cover",width:"100%"}} />
                  {foto.descricao&&<div style={{background:"var(--bg3)",color:"var(--text2)",fontSize:11,padding:"6px 8px"}}>{foto.descricao}</div>}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
}
